import { render, staticRenderFns } from "./data-import.vue?vue&type=template&id=a63da508&scoped=true"
import script from "./data-import.vue?vue&type=script&lang=js"
export * from "./data-import.vue?vue&type=script&lang=js"
import style0 from "./data-import.vue?vue&type=style&index=0&id=a63da508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63da508",
  null
  
)

export default component.exports